<template>
  <div class="ku-scanner">
    <!-- 扫码容器 -->
    <qrcode-stream
        v-show="qrcode"
        :camera="camera"
        :torch="torchActive"
        @decode="onDecode"
        @init="onInit"
    >
      <!-- 扫码界面装饰 -->
      <div class="ku-scanner-content">
        <!-- 返回按钮 -->
        <div class="ku-scanner-back-btn" @click="closeScanner">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="qr-scanner">
          <div class="box">
            <div class="line"></div>
            <div class="angle"></div>
          </div>
        </div>
      </div>
    </qrcode-stream>
  </div>
  </template>

  <script>
  import {
    QrcodeStream
  } from 'vue-qrcode-reader';

    export default {
      name: 'ScanCode',

      data() {
        return {
          result: "", // 扫码结果
          error: "", // 错误信息
          show: false,
          qrcode: true, // 控制扫码组件显示
          torchActive: false, // 闪光灯状态（false 关闭，true 开启）
          camera: "rear", // 摄像头类型（front 前置，rear 后置）
          scrollTop: 0 // 保存滚动位置
        }
      },

      components: {
        QrcodeStream
      },

      mounted() {
        // 组件挂载时禁止页面滚动
        this.disableScroll();
      },

      beforeDestroy() {
        // 组件销毁前恢复页面滚动
        this.enableScroll();
      },

      // 监听组件显示状态变化
      watch: {
        // 监听父组件传递的显示状态
        '$parent.isScannerOpen': {
          handler(newVal) {
            if (newVal) {
              // 组件显示时禁止滚动
              this.$nextTick(() => {
                this.disableScroll();
              });
            } else {
              // 组件隐藏时恢复滚动
              this.enableScroll();
            }
          },
          immediate: true
        }
      },

      methods: {
        /**
         * 关闭扫码器
         */
        closeScanner() {
          // 恢复页面滚动
          this.enableScroll();
          // 向父组件传递关闭信号
          this.$emit("closePopup", false);
        },

        /**
         * 禁止页面滚动
         */
        disableScroll() {
          // 保存当前滚动位置
          this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          // 禁止滚动
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.scrollTop}px`;
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';
        },

        /**
         * 恢复页面滚动
         */
        enableScroll() {
          // 恢复滚动
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          // 恢复滚动位置
          if (this.scrollTop !== undefined) {
            window.scrollTo(0, this.scrollTop);
          }
        },

        /**
         * 扫码成功回调
         * @param {string} result 解析后的二维码内容
         */
        onDecode(result) {
          this.result = result;
          // 向父组件传递扫码结果
          this.$emit("decode", this.result);
          // 可在此处添加自动关闭扫码的逻辑（如：this.qrcode = false）
        },

        /**
         * 组件初始化回调（处理摄像头权限等问题）
         * @param {Promise} promise 摄像头初始化 Promise
         */
        async onInit(promise) {
          try {
            await promise; // 等待摄像头初始化完成
          } catch (error) {
            this.$message.error(error.message); // 统一错误提示
            // 按错误类型处理
            switch (error.name) {
              case "NotAllowedError":
                this.$message.error("请允许摄像头访问权限");
                break;
              case "NotFoundError":
                this.$message.error("该设备无摄像头");
                break;
              case "NotSupportedError":
                this.$message.error("需在 HTTPS 或本地环境运行");
                break;
              case "NotReadableError":
                this.$message.error("相机被其他应用占用");
                break;
              default:
                this.$message.error("扫码初始化失败，请重试");
            }
            // 向父组件传递关闭信号
            this.$emit("closePopup", false);
          }
        }
      }
    }
  </script>


  <style lang="less" scoped>
  /* 扫码界面样式 */
  .ku-scanner {
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    z-index: 3147482200;
    position: absolute;
    inset: 0;

    .ku-scanner-content {
      position: relative;
      height: 100%;

      /* 返回按钮样式 */
      .ku-scanner-back-btn {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 44px;
        height: 44px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;
        transition: background-color 0.3s ease;

        &:hover {
          background: rgba(0, 0, 0, 0.7);
        }

        &:active {
          background: rgba(0, 0, 0, 0.8);
        }
      }

      .ku-scanner-tooltip {
        position: absolute;
        top: 32px;
        left: 0;
        width: 100%;
        color: #fff;
        text-align: center;
        font-size: 14px;
        padding: 0 80px; /* 为返回按钮留出空间 */
      }

      .ku-scanner-section {
        width: 280px;
        height: 280px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 2px solid rgba(25, 137, 250, 0.2);
        overflow: hidden;

        /* 扫描框四角 */
        &:before,
        &:after,
        .ku-scanner-section-angle:before,
        .ku-scanner-section-angle:after {
          content: "";
          position: absolute;
          width: 16px;
          height: 16px;
          border: 2px solid #1989fa;
        }

        &:before {
          top: -2px;
          left: -2px;
          border-bottom: none;
          border-right: none;
        }

        &:after {
          top: -2px;
          right: -2px;
          border-bottom: none;
          border-left: none;
        }

        .ku-scanner-section-angle:before {
          bottom: -2px;
          left: -2px;
          border-top: none;
          border-right: none;
        }

        .ku-scanner-section-angle:after {
          bottom: -2px;
          right: -2px;
          border-top: none;
          border-left: none;
        }

        /* 扫描动画线 */
        .ku-scanner-section-animation-line {
          position: absolute;
          height: 1px;
          width: 100%;
          background: #1989fa;
          top: 50%;
          animation: scan-line 2s infinite;
        }
      }
    }

    .qr-scanner {
      background-image:
          linear-gradient(0deg,
          transparent 24%,
          rgba(32, 255, 77, 0.1) 25%,
          rgba(32, 255, 77, 0.1) 26%,
          transparent 27%,
          transparent 74%,
          rgba(32, 255, 77, 0.1) 75%,
          rgba(32, 255, 77, 0.1) 76%,
          transparent 77%,
          transparent),
          linear-gradient(90deg,
          transparent 24%,
          rgba(32, 255, 77, 0.1) 25%,
          rgba(32, 255, 77, 0.1) 26%,
          transparent 27%,
          transparent 74%,
          rgba(32, 255, 77, 0.1) 75%,
          rgba(32, 255, 77, 0.1) 76%,
          transparent 77%,
          transparent);
      background-size: 3rem 3rem;
      background-position: -1rem -1rem;
      width: 100%;
      /* height: 100%; */
      height: 100vh;
      position: relative;
      background-color: #1110;
      /* background-color: #111; */
    }
    .qr-scanner .box {
      width: 213px;
      height: 213px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;
      border: 0.1rem solid rgba(0, 255, 51, 0.2);
      /* background: url('http://resource.beige.world/imgs/gongconghao.png') no-repeat center center; */
    }
    .qr-scanner .line {
      height: calc(100% - 2px);
      width: 100%;
      background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #00ff33 211%);
      border-bottom: 3px solid #00ff33;
      transform: translateY(-100%);
      animation: radar-beam 2s infinite alternate;
      animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
      animation-delay: 1.4s;
    }
    .qr-scanner .box:after,
    .qr-scanner .box:before,
    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
      content: '';
      display: block;
      position: absolute;
      width: 3vw;
      height: 3vw;
      border: 0.2rem solid transparent;
    }
    .qr-scanner .box:after,
    .qr-scanner .box:before {
      top: 0;
      border-top-color: #00ff33;
    }
    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
      bottom: 0;
      border-bottom-color: #00ff33;
    }
    .qr-scanner .box:before,
    .qr-scanner .angle:before {
      left: 0;
      border-left-color: #00ff33;
    }
    .qr-scanner .box:after,
    .qr-scanner .angle:after {
      right: 0;
      border-right-color: #00ff33;
    }
    @keyframes radar-beam {
      0% {
        transform: translateY(-100%);
      }
      100% {
        transform: translateY(0);
      }
    }
  }

  </style>